import React from 'react'
import { CheckoutSection, formatMoney } from '../../components'
import styles from './checkout.module.css';

const spinnerSpan = <span className="fa fa-spinner fa-spin" />;

const CheckoutSummary = (
    {
        summary: {
            subTotal,
            taxTotal,
            shippingTotal,
            shippingMethod,
            total,
            currency,   
        },
        isRefreshing
    }) => {
    const formatCurrency = formatMoney(currency);
    return (
        <CheckoutSection label='Summary' hidden={false}>
            {isRefreshing
                ? spinnerSpan
                : (
                    <table className={styles.summaryTable} style={{ width: "100%" }}>
                        <tbody>
                            <tr className="subtotal">
                                <td className="summary-label">
                                    Sub Total
                                </td>
                                <td className="summary-amount">
                                    {formatCurrency(subTotal)}
                                </td>
                            </tr>
                            {taxTotal != null &&
                                <tr className="tax">
                                    <td className="summary-label">
                                        Tax
                                    </td>
                                    <td className="summary-amount">
                                        {formatCurrency(taxTotal)}
                                    </td>
                                </tr>
                            }
                            {shippingTotal != null &&
                                <tr className="shipping">
                                    <td className="summary-label">
                                        Shipping
                                    </td>
                                    <td className="summary-amount">
                                        {formatCurrency(shippingTotal)}
                                    </td>
                                </tr>
                            }
                            <tr className={styles.total}>
                                <td className="total-label">
                                    Total
                                </td>
                                <td className="total-amount">
                                    {formatCurrency(total)}
                                </td>
                            </tr>
                        </tbody>
                    </table>)}
        </CheckoutSection>
    );
}

export default CheckoutSummary